import { toUpper } from 'lodash';
import { selection, raceTypes, timePeriods } from '../../utils/filter';

const raceCategoryOptions = {
    big: {
        label: 'Big races',
        value: 'big-race',
    },
    all: {
        label: 'All races',
        value: 'all-races',
    },
};

const raceCategoryFactory = (statusType) => {
    const { all, big } = raceCategoryOptions;
    const options = statusType === 'big-race' ? [big, all] : [all];

    return {
        options: selection.setSelected(options, statusType),
        title: 'race category',
    };
};

const raceTypeFactory = (typeCode, raceType) => ({
    title: 'race type',
    options: selection.setSelected(raceTypes.getForCourse(typeCode), raceType),
});

export const timePeriodFactory = (raceType, principalSeason, seasonsAvailable) => ({
    options: selection.setSelected(
        timePeriods.getAvailable(seasonsAvailable, toUpper(raceType), true),
        principalSeason.toString()
    ),
    title: 'time period',
    createdBy: {
        seasonsAvailable,
        principalSeason,
        raceType,
    },
});

const categoriesFactory = (
    raceStatusType, courseTypeCode, raceType, coursePrincipalSeason = 0, seasonsAvailable
) => (
    seasonsAvailable ? {
        raceCategory: raceCategoryFactory(raceStatusType),
        raceType: raceTypeFactory(courseTypeCode, raceType),
        timePeriod: timePeriodFactory(raceType, coursePrincipalSeason, seasonsAvailable),
    } : null
);

export default categoriesFactory;



// WEBPACK FOOTER //
// ./src/js/course/results/categories.js